/**
 * Toggle Search Container
 */
const handleSearch = () => {
  const $searchContainer = $(".header__search");

  $searchContainer.toggleClass("is-active");
  if ($searchContainer.hasClass("is-active")) {
    $searchContainer.find("input.search__field").focus();
  }
};

/**
 * Call handleSearch function on click on search trigger
 */
$(".search-trigger, .search__close").on("click", function (event) {
  handleSearch();

  event.preventDefault();
});

/**
 * Clear header search on close
 */

$("#js-header-search-close").on("click", function () {
  $("#js-header-search-close").prev().val("");
});
